import { jsx as _jsx } from "react/jsx-runtime";
import { SliderFactory } from './SliderFactory';
export function OpacitySlider(props) {
    const valueFormatter = (value) => `${Math.round(value * 100)} %`;
    return (_jsx(SliderFactory, { ...props, min: 0, max: 1, step: 0.01, as: 'OpacitySlider', valueFormatter: valueFormatter }));
}
//# sourceMappingURL=OpacitySlider.js.map